import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListChannelsAssociatedWithChannelFlow } from "../schemas/schemas_0";
export { $Command };
export class ListChannelsAssociatedWithChannelFlowCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [getEndpointPlugin(config, Command.getEndpointParameterInstructions())];
})
    .s("ChimeMessagingService", "ListChannelsAssociatedWithChannelFlow", {})
    .n("ChimeSDKMessagingClient", "ListChannelsAssociatedWithChannelFlowCommand")
    .sc(ListChannelsAssociatedWithChannelFlow)
    .build() {
}
